import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBarsTwo: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconBarsTwo"><Path d="M2.5 7.5H21.5M2.5 16.5H21.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconBarsTwo;
